module.exports = __webpack_public_path__ + "img/arrow-right.63b0707f.svg";